import styled from "styled-components";

export const StyledEffectPanelContainer = styled.div`
  position: absolute;
`;
